// start:ng42.barrel
import './languagecode.service';
// end:ng42.barrel

